export const HAKLAI_2990_DEFAULTS = Object.freeze({
  lishcatRishumLocation: "תל אביב"
});

export const HAKLAI_2990_LISHKAT_RISHUM_OPTIONS = Object.freeze([
  { label: "תל אביב", value: "תל אביב" },
  { label: "מרכז", value: "מרכז" },
  { label: "חדרה", value: "חדרה" },
  { label: "פתח תקווה", value: "פתח תקווה" },
  { label: "חיפה", value: "חיפה" },
  { label: "ירושלים", value: "ירושלים" },
  { label: "נתניה", value: "נתניה" },
  { label: "באר שבע", value: "באר שבע" },
  { label: "נצרת", value: "נצרת" },
  { label: "רחובות", value: "רחובות" },
  { label: "חולון", value: "חולון" },
  { label: "טבריה", value: "טבריה" }
]);

export const HAKLAI_2990_FIELD_LABELS = Object.freeze({
  blockNum: "גוש",
  subBlock: "חלקה",
  subSubBlock: "תת חלקה",
  assetZipcode: "מיקוד הנכס",
  assetCity: "ישוב",
  assetStreet: "רחוב",
  assetStreetNumber: "מספר בית",
  assetHouseNum: "מספר דירה",
  lishcatRishumLocation: "מקום משרד מיסוי המקרקעין",
  sellerFirstName: "שם פרטי",
  sellerLastName: "שם משפחה",
  sellerId: "מספר זהות"
});

export const HAKLAI_2990_FIELD_TOOLTIPS = Object.freeze({
  sellerId:
    "במידה ומדובר בתושב חוץ ללא תעודת זהות, יש לפנות לרשות על מנת לקבל מספר רישוי מיוחד שישמש לעסקה"
});

export const HAKLAI_2990_LABELS = Object.freeze({
  panelTitle: "מילוי פרטים אישיים לטופס 2990",
  propertyDetails: "פרטי הנכס",
  propertyLookup: "איתור פרטי נכס לפי כתובת",
  sellerAndRegistration: "פרטי מוכר ורישום",
  transferredShare: "החלק הנמכר",
  numerator: "מונה",
  denominator: "מכנה",
  onlineFiles: "קבצים מקוונים לרשות המיסים",
  exportRoutesAvailable: "מסלולי ייצוא זמינים",
  dealNumberPrefix: "עסקה מספר",
  blockPrefix: "גוש",
  parcelPrefix: "חלקה"
});

export const HAKLAI_2990_ACTIONS = Object.freeze({
  searchPropertyDetails: "אתר פרטי נכס",
  savePersonalDetails: "שמור פרטים אישיים",
  generateForm2990: "הפק טופס 2990",
  generateDeductions: "הפק טופס ניכויים",
  generateMutavFile: "קובץ מס מוטב",
  generateLinearFile: "קובץ לינארי ישן"
});

export const HAKLAI_2990_MESSAGES = Object.freeze({
  loadError: "לא ניתן היה לטעון נתוני 2990 שמורים. אפשר להמשיך ולהזין ידנית.",
  smartAddressAutofill:
    "פרטי הנכס מולאו לפי הכתובת. ניתן לערוך אותם במידת הצורך.",
  smartAddressFormatError: "פורמט הכתובת לא תקין. לדוגמה: הרצל 10, תל אביב.",
  govMapUnavailable: "איתור GovMap אינו זמין כרגע",
  addressNoMatch: "לא נמצאה התאמה לכתובת שהוזנה",
  addressSearchFailed: "החיפוש לפי כתובת נכשל. נסו שוב או מלאו את הפרטים ידנית.",
  saveErrorTitle: "שגיאה",
  saveFailed: "לא ניתן לשמור את נתוני 2990",
  saveSucceeded: "נתוני 2990 נשמרו בהצלחה",
  documentGenerationFailedTitle: "היתה בעיה ביצירת המסמך",
  documentGenerationFailedText: "במידה ובעיה זו ממשיכה בבקשה צרו איתנו קשר",
  invalidExportSnapshot: "לא ניתן ליצור קבצי 2990 מנתוני ניתוח ללא מזהי נכס תקינים.",
  exportFilesEmpty: "קבצי ייצוא יוצגו כאן לאחר ניתוח עסקה מחושב.",
  noExportRoutesForPart: "אין מסלולי ייצוא זמינים עבור רכיב זה."
});

export const HAKLAI_2990_VALIDATION_MESSAGES = Object.freeze({
  summary: "לא ניתן ליצור קובץ דיווח עד להשלמת נתוני הטופס",
  missingSellerFirstName: "שם פרטי חסר",
  missingSellerLastName: "שם משפחה חסר",
  missingLishcatRishumLocation: "לשכת רישום חסרה",
  missingSellerId: "ת.ז חסרה",
  missingBlockNum: "גוש חסר",
  missingSubBlock: "חלקה חסרה",
  missingAssetStreet: "רחוב חסר",
  missingAssetStreetNumber: "מספר בית חסר",
  missingFractionNumerator: "מונה החלק הנמכר חסר",
  missingFractionDenominator: "מכנה החלק הנמכר חסר",
  invalidSellerId: "לפחות 9 ספרות",
  fractionNumeratorMustUseInteger: "מונה מספר שלם",
  fractionDenominatorMustUseInteger: "מכנה מספר שלם",
  fractionNumeratorMustBePositive: "מונה גדול מאפס",
  fractionDenominatorMustBePositive: "מכנה גדול מאפס",
  parcelRange: "חלקה חייבת להיות בין 0 ל-9999"
});

export const HAKLAI_2990_SMART_ADDRESS_HELP = Object.freeze({
  formatsTitle: "פורמטים נתמכים:",
  formats: Object.freeze([
    "רחוב מספר, עיר",
    "רחוב מספר עיר",
    "רחוב מספר/דירה, עיר",
    "רחוב מספר דירה 3, עיר",
    "רחוב מספר כניסה 3, עיר",
    "אפשר להוסיף מיקוד בסוף"
  ]),
  examplesTitle: "דוגמאות:",
  examples: Object.freeze([
    "הרצל 10, תל אביב",
    "הרצל 10/3, תל אביב 6701101",
    "הרצל 10 דירה 3, תל אביב"
  ]),
  placeholder: "הרצל 10, תל אביב"
});

export const HAKLAI_2990_SMART_ADDRESS_PARSER_TOKENS = Object.freeze([
  "דירה",
  "כניסה"
]);

export const getHaklai2990ExportGroupTitle = (index, partsAmount) => (
  partsAmount > 1
    ? `${HAKLAI_2990_LABELS.dealNumberPrefix} ${index + 1}`
    : HAKLAI_2990_LABELS.exportRoutesAvailable
);

export const getHaklai2990ParcelChoiceLabel = (pair) => (
  `${HAKLAI_2990_LABELS.blockPrefix} ${pair.gush}, ${HAKLAI_2990_LABELS.parcelPrefix} ${pair.helka}`
);
